/**
 * Get badge style based on group role
 */
export function getRoleBadgeStyle(role: string): string {
  switch (role) {
    case "owner":
      return "bg-emerald-100 text-emerald-700 dark:bg-emerald-900 dark:text-emerald-300";
    case "editor":
      return "bg-blue-100 text-blue-700 dark:bg-blue-900 dark:text-blue-300";
    default:
      return "bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-300";
  }
}

/**
 * Get invitation status badge style
 */
export function getInvitationBadgeStyle(): string {
  return "bg-amber-100 text-amber-700 dark:bg-amber-900 dark:text-amber-300";
}

/**
 * Get guest badge style
 */
export function getGuestBadgeStyle(): string {
  return "rounded-full bg-yellow-100 px-2 py-0.5 text-xs text-yellow-700 dark:bg-yellow-900 dark:text-yellow-300";
}

/**
 * Format invitation expiry date
 */
export function formatInvitationExpiry(expiresAt: string | null | undefined): string | null {
  if (!expiresAt) return null;
  return new Date(expiresAt).toLocaleDateString();
}

/**
 * Format invitation usage count
 */
export function formatInvitationUsage(
  usedCount: number,
  maxUses: number | null | undefined
): string {
  if (maxUses) {
    return `${usedCount} / ${maxUses}`;
  }
  return `${usedCount}`;
}

/**
 * Determine if a member can be modified (not owner)
 */
export function canModifyMember(role: string): boolean {
  return role !== "owner";
}

/**
 * Determine FAB actions based on permissions
 */
export interface FabAction {
  icon: React.ComponentType;
  label: string;
  onClick: () => void;
}

export function determineFabActions(
  canEdit: boolean,
  isOwner: boolean,
  hasDefaultSession: boolean,
  onAddExpense: () => void,
  onInvite: () => void,
  icons: { Plus: React.ComponentType; UserPlus: React.ComponentType },
  labels: { addExpense: string; invite: string }
): FabAction[] {
  const actions: FabAction[] = [];

  if (canEdit && hasDefaultSession) {
    actions.push({
      icon: icons.Plus,
      label: labels.addExpense,
      onClick: onAddExpense,
    });
  }

  if (isOwner) {
    actions.push({
      icon: icons.UserPlus,
      label: labels.invite,
      onClick: onInvite,
    });
  }

  return actions;
}
